var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.langs),function(lang,i){return _c('div',{key:`Lang${i}`},[(_vm.$i18n.locale !== lang.lang)?_c('button',{staticClass:"locale-button",on:{"click":function($event){return _vm.onLocaleChange(_vm.$i18n, lang.lang)}}},[_vm._v(" "+_vm._s(_vm.langs[i].title)+" ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }